import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "./Header";
import Footer from "./Footer";
import { isBrowser } from "../../utilities/checkEnvironment";
import { useTheme } from "../../context/ThemeContext";
import "../../styles/main.scss";

const Layout = ({ children }) => {
  const { settings } = useTheme();
  const { code_for_head: codeHead, code_for_body: codeBody } = settings.data;
  const [thinHeader, setThinHeader] = useState(false);
  const controlHeader = () => {
    if (isBrowser) {
      if (window.scrollY > 200) {
        setThinHeader(true);
      } else if (window.scrollY <= 130) {
        setThinHeader(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", controlHeader);
    return () => {
      window.removeEventListener("scroll", controlHeader);
    };
  }, []);

  useEffect(() => {
    if (codeHead.text !== "") {
      document.head.append(
        document.createRange().createContextualFragment(codeHead.text)
      );
    }
    if (codeBody.text !== "") {
      document.body.append(
        document.createRange().createContextualFragment(codeBody.text)
      );
    }
  }, [codeBody.text, codeHead.text]);

  return (
    <>
      <Helmet defaultTitle={settings.data.site_short_title}>
        <html lang={settings.lang} />
      </Helmet>

      <div className="site">
        <Header settings={settings} thinHeader={thinHeader} />

        <main className="site-main">{children}</main>

        <Footer footer_menu={settings.data.footer_menu} />
      </div>
    </>
  );
};

export default Layout;
